import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { HlPercentageDropDownData } from './hl-percentage-drop-down-model';

export class HlPercentageDropDownDataResponseModel extends GlobalResponseObject{
    data?: HlPercentageDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //HlPercentageDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: HlPercentageDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}